<template>
  <v-app
    id="launcher"
  >
    <router-view />
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">

  a {
    text-decoration: none;
  }

  #page-container {
    background-size: cover;

    #page-content {
      height: 100px;
      margin-left: 60px;
      width: calc(100% - 60px);
      
      #page-body {
        background-color: #fafafa;
      }
    }
  }

  .section-header {
      font-weight: 700;
      font-size: 1.625rem;
      line-height: 1.75rem;
      letter-spacing: .1em;
      text-transform: uppercase;
      margin-bottom: 18px;
      padding-top: 24px !important;
      padding-bottom: 0 !important;
      text-align: center;

      &:after {
        content: ' ';
        display: block;
        width: 200px;
        height: 10px;
        margin: 0 auto;
        border-bottom: 1px solid #ddd;
      }
  }


  .card-list { // inspired by https://uxdesign.cc/creating-horizontal-scrolling-containers-the-right-way-css-grid-c256f64fc585
    display: grid;
    grid-gap: calc(var(--gutter) * 1.5 + 1vw);
    grid-template-columns: 1rem;
    grid-template-rows: minmax(7rem, 1fr);
    grid-auto-flow: column;
    grid-auto-columns: 320px; // small viewports
    @media (min-width: 800px) {
        // grid-auto-columns: calc(var(--gutter) * 12);
    }
    overflow-x: scroll;
    scroll-snap-type: x proximity;
    scroll-snap-points-x: repeat(100%);
    scroll-snap-type: mandatory;
    scroll-snap-destination: 100% 0%;
    padding-bottom: calc(.75 * var(--gutter));
    margin-bottom: calc(-.25 * var(--gutter));
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (min-width: 800px) { // yeah make this large-viewport only
        &:hover {
          .item {
              opacity: 0.6;
              filter: blur(2px);
              // transition-delay: 0.3s;
          }
        }
    }
  }
  .mask-right {
    @media screen and (min-width: 640px) {
        mask: linear-gradient(-90deg, rgba(0,0,0,0) 3%, rgba(0,0,0,1) 20%);
        -webkit-mask: linear-gradient(-90deg, rgba(0,0,0,0) 3%, rgba(0,0,0,1) 20%);
    }
  }
  .flag {
    transition: all var(--speed) ease;
    transform: translate3d(6rem, -6rem, 0) rotate(45deg);
  }
  .card-list:before,
  .card-list:after {
    content: '';
    width: 10px;
  }
  .item {
    scroll-snap-align: center;
    padding: calc(var(--gutter) / 2 * 1.5);
    transition: all var(--speed);
    &:hover {
        opacity: 1 !important;
        filter: blur(0) !important;
        box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
        
        .flag {
          transform: translate3d(4rem, -4rem, 0) rotate(45deg); // greater the offset value here, smaller the 'tag' is
        }
    }
  }
  .item:nth-last-child {
    margin-right: 5rem;
  }
  .lozad {
    transition: opacity var(--speed);
    opacity: 0;
  }
  .lozad.loaded {
    opacity: 1;
  }
  .toggled {
    transition: opacity var(--speed);
    transition-delay: var(--speed);
    opacity: 1;
  }
  .no-scrollbar {
    scrollbar-width: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }


  .is-active { // when toggle is triggered, the target gets .is-active
    display: block;
  }
  $speed-default: 150ms;
  .icon, .toggle-me, .nav-item {
    transition: all var(--speed) ease; // for production: just apply to [color | position | opacity]
  }
  .is-toggled {
    // border-color: gold;
    color: black;
    .icon-default {
        display: none;
        // opacity: 0;
    }
    .icon-active {
        display: block;
        // opacity: 1;
    }
  }

  // == working on some transitions for menu elements. 

  // a.nav-item {
  //    transition: opacity 0.2s, transform 0.2s ease;
  //    transform: translate3D(0, 3px, 0);
  //    opacity: 0;
  // }
  .nav-items {
    @for $i from 1 through 6 {
        // add a small bit of delay for n children. Estimating 8
        $t: 0.05s * $i + 0.2s;
        &:nth-child(#{$i}) a {
          transition-delay: $t;
        }
    }
  }
  .toggle-target.is-active .nav-items a.nav-item {
    transform: translate3D(0, 0, 0);
    opacity: 1;
  }

  %prefade {
      transition: opacity 0.2s, transform 0.2s ease;
      transform: translate3D(-4px, 0, 0);
      transition-delay: 0.8s;
      opacity: 0;
  }
  .fade-1 { // might need a coherent timing function, so delays are coordinated
      @extend %prefade;
      transition-delay: 0.8s;
  }


  .card {
    height: 100%;
    overflow: hidden;

    &:hover {
      cursor: pointer;
      text-decoration: none;
      -webkit-transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      -webkit-transition-property: -webkit-box-shadow;
      transition-property: -webkit-box-shadow;
      transition-property: box-shadow;
      transition-property: box-shadow, -webkit-box-shadow;
    }

    .card-thumb {
        // max-height: 150px;
    }

    .v-card__title {
      padding: 10px;

      .card-title {
          font-weight: 700;
          font-size: 1.125rem;
          line-height: 1.25rem;
          word-break: break-word;
          cursor: pointer;
      }
    }

    .card-description {
      text-align: left;
    }

  }

</style>